<template>
  <v-container fluid>
    <v-card>
      <v-card-text>
        <v-row v-if="showChartFour" >
          <v-col class="col-lg-4 col-md-12 col-sm-12 justify-content" align-self="center">
            <v-select
                v-model="IdUnidade"
                :items="unidadesList"
                item-text="Unidade"
                item-value="IdUnidade"
                label="Unidade"
                @change="[getQuantidadesDatacom($event), getCharts($event)]"
                hide-details
                outlined
                dense
                clearable
            ></v-select>
          </v-col>
          <v-col :class="IdUnidade != null || dateStart != null 
            ? 'col-lg-6 col-md-12 col-sm-12' 
            : 'col-lg-8 col-md-12 col-sm-12'"
          >
            <DatePickerRange 
              :dateStart="dateStart" 
              :dateFinish="dateFinish" 
              @date:start="refreshStart" 
              @date:finish="refreshFinish"
            >
            </DatePickerRange>
          </v-col>
          <v-col class="col-lg-2 col-md-12 col-sm-12" align-self="center" v-if="IdUnidade != null || dateStart != null">
            <v-btn color="primary" width="100%" v-bind:id="dynamicCol='3'" @click="[dynamicCol=4, dynamicColMap=4, limparFiltros()]"
                   dark>
              Limpar Filtros
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 4">
            <v-card>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">{{ this.totalEmpresasAtendidas }}</v-list-item-title>
                  <v-list-item-subtitle v-if="!$vuetify.breakpoint.xsOnly">Quantidade de empresas atendidas</v-list-item-subtitle>
                </v-list-item-content>
                <v-icon large color="primary">mdi-domain</v-icon>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 4">
            <v-card>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">{{ this.totalAtendimentosEmpresa }}</v-list-item-title>
                  <v-list-item-subtitle v-if="!$vuetify.breakpoint.xsOnly">Quantidade de atendimentos realizados nas empresas</v-list-item-subtitle>
                </v-list-item-content>
                <v-icon large color="primary">mdi-hospital-box</v-icon>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 4">
            <v-card>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">{{ this.totalMunicipiosAtendidos }}</v-list-item-title>
                  <v-list-item-subtitle v-if="!$vuetify.breakpoint.xsOnly">Quantidade de municípios atendidos</v-list-item-subtitle>
                </v-list-item-content>
                <v-icon large color="primary">mdi-city-variant</v-icon>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 3">
            <v-card>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">{{ this.agendamentosTotal }}</v-list-item-title>
                  <v-list-item-subtitle v-if="!$vuetify.breakpoint.xsOnly">Total de agendamentos</v-list-item-subtitle>
                </v-list-item-content>
                <v-icon large color="primary">mdi-calendar</v-icon>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 3">
            <v-card>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">{{ this.agendamentosAgendados }}</v-list-item-title>
                  <v-list-item-subtitle v-if="!$vuetify.breakpoint.xsOnly">Agendamentos futuros</v-list-item-subtitle>
                </v-list-item-content>
                <v-icon large color="primary">mdi-calendar-clock</v-icon>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 3">
            <v-card>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">{{ this.agendamentosHoje }}</v-list-item-title>
                  <v-list-item-subtitle v-if="!$vuetify.breakpoint.xsOnly">Agendamentos hoje</v-list-item-subtitle>
                </v-list-item-content>
                <v-icon large color="primary">mdi-calendar-cursor</v-icon>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 3">
            <v-card>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">{{ this.agendamentosConcluidos }}</v-list-item-title>
                  <v-list-item-subtitle v-if="!$vuetify.breakpoint.xsOnly">Agendamentos concluídos</v-list-item-subtitle>
                </v-list-item-content>
                <v-icon large color="primary">mdi-calendar-check</v-icon>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>

        <v-card class='my-8'>
          <v-card-title>
            <v-row>
              <v-col cols=10>
                Resumo dos contratos nos últimos {{contractsSummaryDayInterval}} dias
              </v-col>
              <v-col cols=2>
                <v-select
                  outlined dense hide-details
                  v-model='contractsSummaryDayInterval'
                  :items='[7, 15, 30, 45, 60]'
                  class='text-body-1'
                  label='Intervalo de dias'
                />
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <apexchart
              v-if='!contractsSummaryChartLoading'
              type='bar'
              height=350
              :options='contractsSummaryOptions'
              :series='contractsSummarySeries'
            />
            <v-sheet
              v-else
              height=350
              class='d-flex justify-center align-center'
            >
              <v-progress-circular
                indeterminate
                size=80
                width=10
                color='primary'
              />
            </v-sheet>
          </v-card-text>
        </v-card>

        <div class="row" v-if="showMap">
          <div class="col-xl-12 col-lg-12">
            <div class="card shadow mb-4">
              <v-card class="pa-2">
                <div class="card-header py-3 d-flex flex-row">
                  <span style="font-size: 1em;font-family: Helvetica;font-weight: bold;margin-left: 1%">Quantidade de empresas por município</span>
                </div>
                <div class="card-body foobar1" style="height: 400px; width: 100%;z-index:0;position: relative">

                  <l-map v-if="showMap"
                         :zoom="zoom"
                         :center="center"
                         :options="mapOptions"
                         @update:zoom="zoomUpdated"
                         @update:center="centerUpdated"
                         @update:bounds="boundsUpdated"
                  >
                    <l-tile-layer :url="url"></l-tile-layer>
                    <l-choropleth-layer v-if="showMap"
                                        :data="arrayNormalizado"
                                        titleKey="nome"
                                        idKey="codarea"
                                        :value="value"
                                        :extraValues="extraValues"
                                        geojsonIdKey="codarea"
                                        :geojson="geoJson"
                                        :colorScale="colorScale"
                                        referenceTitle="Quantidade de empresas"
                                        dataTitle="Empresa"
                                        dataPlaceholder="Escolha um município">
                      <template slot-scope="props">
                      <l-info-control
                            :item="props.currentItem"
                            :unit="props.unit"
                            title="Informações"
                            placeholder="Leve o mouse a um local"/>
                        <l-reference-chart
                            title="Quantidade de empresas por município"
                            :colorScale="colorScale"
                            :min="props.min"
                            :max="props.max"
                            position="topright"/>
                      </template>
                    </l-choropleth-layer>
                  </l-map>
                </div>
              </v-card>
            </div>
          </div>
        </div>

        <!-- <v-row>
          <v-col cols="12">
            <v-card :class="$vuetify.breakpoint.mdAndDown ? '' : 'pa-2'">
              <v-card-title>Faturamento por mês de cada unidade</v-card-title>
              <v-card-text>  
                <apexchart v-if="showChartZero" type="line" height="350px" :options="chartOptionsZero" :series="seriesZero"></apexchart>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card :class="$vuetify.breakpoint.mdAndDown ? '' : 'pa-2'">
              <v-card-title>Valor pago e devido das faturas por mês</v-card-title>
              <v-card-text> 
                <apexchart v-if="showChartZeroTwo" type="bar" height="350px" :options="chartOptionsZeroTwo" :series="seriesZeroTwo"></apexchart>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col>
            <v-card>
              <v-card-title>
                <v-col cols=10>Listagem dos {{ programaExame === 1 ? 'programas' : 'exames' }}  realizados</v-col>
                <v-col cols=2>
                    <v-select
                      outlined dense hide-details
                      v-model='programaExame'
                      item-value="id"
                      item-text="name"
                      :items="[{ id: 1, name: 'Programas' }, { id: 0, name: 'Exames' }]"
                      class='text-body-1'
                      label='Tipo'
                    />
                  </v-col>
              </v-card-title>
                <v-card-text>
                  <apexchart type="bar" height="400px" :options="chartOptionsProgramasExames" :series="seriesProgramasExames"></apexchart>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
            <v-card :class="$vuetify.breakpoint.mdOnly ? '' : 'pa-2'">
              <v-card-title>5 empresas com mais atendimentos</v-card-title>
              <v-card-text :style="$vuetify.breakpoint.mdAndUp ? 'height: 400px;' : ''">
                <apexchart v-if="showChartTwo" type="donut" height="350px" :options="chartOptionsTwo" :series="chartOptionsTwo.seriesTwo"></apexchart>
              </v-card-text> 
            </v-card>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
            <v-card :class="$vuetify.breakpoint.mdAndDown ? '' : 'pa-2'">
              <v-card-title>5 municípios com mais atendimentos</v-card-title>
              <v-card-text :style="$vuetify.breakpoint.mdAndUp ? 'height: 400px;' : ''">
                <apexchart v-if="showChartThree" type="radialBar" height="350px" :options="chartOptionsThree" :series="seriesThree"></apexchart>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col  cols="12">
            <v-card :class="$vuetify.breakpoint.mdAndDown ? '' : 'pa-2'">
              <v-card-title>Indicadores de atendimentos e serviços</v-card-title>
              <v-card-text>
                <apexchart v-if="showChartFour" type="bar" height="350px" :options="chartOptionsFour" :series="seriesFour"></apexchart>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
            <v-card :class="$vuetify.breakpoint.mdAndDown ? '' : 'pa-2'">
              <v-card-title>Empresas atendidas por município</v-card-title>
              <v-card-text>
                <apexchart v-if="showChartFive" type="bar" height="350px" :options="chartOptionsFive" :series="seriesFive"></apexchart>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
            <v-card :class="$vuetify.breakpoint.mdAndDown ? '' : 'pa-2'">
              <v-card-title>Agendamentos por dia da semana</v-card-title>
              <v-card-text>
                <apexchart v-if="showChartSix" type="line" height="350px" :options="chartOptionsSix" :series="seriesSix"></apexchart>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import moment from "moment"
import DatePickerRange from "../components/DatePickerRange.vue"

export default {
  name: "Dashboard",
  components: {
    DatePickerRange
  },
  data: () => ({
    programaExame: null,
    dateStart: moment().set('date', 1).format('YYYY-MM-DD'),
    dateFinish: moment().format('YYYY-MM-DD'),
    programas: [],
    exames: [],
    seriesZero: [{
      data: []
    }],
    chartOptionsZero: {
      chart: {
        height: 350,
        type: 'line',
        dropShadow: {
          enabled: true,
          color: '#000',
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2
        },
        toolbar: {
          show: false
        }
      },
      colors: ['#77B6EA', '#545454', '#26970f'],
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: 'smooth'
      },
      grid: {
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        },
      },
      markers: {
        size: 1
      },
      xaxis: {
        categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            return "R$ " + (value) + ',00';
          }
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        floating: true,
        offsetY: -25,
        offsetX: -5
      }
    },

    contractsSummaryChartLoading: true,
    contractsSummaryDayInterval: 30,
    contractsSummarySeries: [
      {
        name: 'Novos',
        data: []
      },
      {
        name: 'Agendado',
        data: []
      },
      {
        name: 'Atendimento iniciado',
        data: []
      },
      {
        name: 'Faturado',
        data: []
      }
    ],

    contractsSummaryOptions: {
      chart: {
        type: 'bar',
        height: 430
      },
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: 'top',
          },
        }
      },
      noData: {
        text: 'Sem dados disponíveis'
      },
      dataLabels: {
        enabled: true,
        offsetX: 0,
        offsetY: -20,
        style: {
          fontSize: '14px',
          colors: ['#000']
        }
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['#fff']
      },
      xaxis: {
        categories: [],
        labels: {
          show: true
        }
      },
      yaxis:{
        labels:{
          style: {
            colors: [],
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 400,
            cssClass: 'apexcharts-xaxis-label',
          }
        }
      }
    },

    seriesZeroTwo: [
      {
        name: "Valor Pago",
        data: [0,0,0,0,0,0,0,0,0,0,0,0]
      },
      {
        name: "Valor Devido",
        data: [0,0,0,0,0,0,0,0,0,0,0,0]
      }
    ],
    chartOptionsZeroTwo: {
      chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: true
        }
      },
      colors: ['#195C13FF', '#ac0f0f'],
      responsive: [{
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0
          }
        }
      }],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10
        },
      },
      xaxis: {
        categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            if (value >= 2) {
              return "R$ " + (value) + ',00';
            } else {
              return "R$ " + (value);
            }
          }
        },
      },
      legend: {
        position: 'right',
        offsetY: 40
      },
      fill: {
        opacity: 1
      }
    },
    chartOptionsProgramasExames: {
      title: {
        text: "",
        align: "center",
      },
      chart: {
        type: 'bar'
      },
      plotOptions: {
        bar: {
          horizontal: true,
        }
      },
      dataLabels: {
        enabled: false
      },
      noData: {
        text: 'Carregando...'
      },
      xaxis: {
        categories: [],
      },
    },
    seriesProgramasExames: [
      {
        name: "",
        data: []
      }
    ],
    chartOptionsTwo: {
      dataLabels: {
        enabled: false
      },
      noData: {
        text: 'Carregando...'
      },
      seriesTwo: [],
      chart:{
        id: "Gráfico-empresas-atendimentos",
        type: 'donut',
        toolbar:{
          show:false,
          tools:{
            download: true
          }
        }
      },
      labels: [],
      legend: {
        position: 'bottom'
      },
      subtitle: {
        text: ''
      },
      responsive: [{
        breakpoint: 1263,
        options: {
          legend: {
            position: 'bottom'
          }
        }
      }]
    },
    seriesThree: [],
    chartOptionsThree: {
      chart: {
        type: 'radialBar',
        toolbar:{
          show:false,
          tools:{
            download: true
          }
        }
      },
      noData: {
        text: 'Carregando...'
      },
      plotOptions: {
        radialBar: {
          offsetY: 0,
          startAngle: 0,
          endAngle: 270,
          hollow: {
            margin: 5,
            size: '30%',
            background: 'transparent',
            image: undefined,
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: false,
            }
          }
        }
      },
      colors: ['#1ab7ea', '#0084ff', '#39539E', '#0077B5'],
      labels: [],
      legend: {
        show: true,
        floating: true,
        fontSize: '14px',
        position: 'left',
        offsetX: -30,
        offsetY: 0,
        labels: {
          useSeriesColors: true,
        },
        markers: {
          size: 0
        },
        formatter: function(seriesName, opts) {
          return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex]
        },
        itemMargin: {
          vertical: 3
        }
      },
      responsive: [{
        breakpoint: 1263,
        options: {
          legend: {
            fontSize: '10px',
            position: 'left',
            offsetX: -40,
            show: true
          }
        }
      }]
    },
    seriesFour: [{
      name: "Agendados",
      data: []
    }, {
      name: "Realizados",
      data: []
    }, {
      name: "Não Faturados",
      data: []
    }],
    chartOptionsFour: {
      chart: {
        type: 'bar',
        height: 430,
        toolbar:{
          show:false,
          tools:{
            download: true
          }
        }
      },
      noData: {
        text: 'Carregando...'
      },
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: 'top',
          },
        }
      },
      dataLabels: {
        enabled: true,
        offsetX: 0,
        offsetY: -20,
        style: {
          fontSize: '14px',
          colors: ['#000']
        }
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['#fff']
      },
      xaxis: {
        categories: [],
        labels: {
          show: true
        }
      },
      yaxis:{
        labels:{
          style: {
            colors: [],
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 400,
            cssClass: 'apexcharts-xaxis-label',
          }
        }
      }

    },

    seriesFive: [{
      name: 'Quantidade de empresas atendidas',
      data: []
    }],
    chartOptionsFive: {
      chart: {
        height: 350,
        type: 'bar',
      },

      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val;
        },
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        labels: {
          show: true,
        }
      }
    },
    seriesSix: [{
      name: 'Atendimentos',
      type: 'column',
      data: []
    }, {
      name: 'Agendamentos',
      type: 'area',
      data: []
    }, {
      name: 'Média de agendamentos',
      type: 'line',
      data: []
    }],
    chartOptionsSix: {
      chart: {
        height: 350,
        type: 'line',
        stacked: false,
        toolbar: {
          show: false
        },
      },
      stroke: {
        width: [0, 2, 5],
        curve: 'smooth'
      },
      plotOptions: {
        bar: {
          columnWidth: '50%'
        }
      },
      noData:{
        text: ''
      },
      fill: {
        opacity: [0.85, 0.25, 1],
        gradient: {
          inverseColors: false,
          shade: 'light',
          type: "vertical",
          opacityFrom: 0.85,
          opacityTo: 0.55,
          stops: [0, 100, 100, 100]
        }
      },
      labels: ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta'],
      markers: {
        size: 0
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            return value.toFixed();
          }
        },
      },
      xaxis: {
        labels: {
          formatter: function (value) {
            return value;
          }
        }
      }
    },
    arrayXaxis: [],
    arrayYaxis: [],
    totalMunicipiosAtendidos: null,
    totalEmpresasAtendidas: null,
    totalAtendimentosEmpresa: 0,
    agendamentosTotal: 0,
    agendamentosAgendados: 0,
    agendamentosHoje: 0,
    agendamentosConcluidos: 0,
    IdUnidade: null,
    unidadesList: [],
    periodosList: [
      {
        IdMes: 1,
        Mes: 'Janeiro'
      },
      {
        IdMes: 2,
        Mes: 'Fevereiro'
      },
      {
        IdMes: 3,
        Mes: 'Março'
      },
      {
        IdMes: 4,
        Mes: 'Abril'
      },
      {
        IdMes: 5,
        Mes: 'Maio'
      },
      {
        IdMes: 6,
        Mes: 'Junho'
      },
      {
        IdMes: 7,
        Mes: 'Julho'
      },
      {
        IdMes: 8,
        Mes: 'Agosto'
      },
      {
        IdMes: 9,
        Mes: 'Setembro'
      },
      {
        IdMes: 10,
        Mes: 'Outubro'
      },
      {
        IdMes: 11,
        Mes: 'Novembro'
      },
      {
        IdMes: 12,
        Mes: 'Dezembro'
      }
    ],    
    anoList: [
      {
        IdAno: moment().format('YYYY'),
      },
      //ano anterior
      {
        IdAno: moment().format('YYYY')-1,
      }
    ],
    FaturamentoList:[],
    dynamicCol: 4,
    dynamicColMap: 4,
    showChartZero: false,
    showChartZeroTwo: false,
    showChartOne: false,
    showChartTwo: false,
    showChartThree: false,
    showChartFour: false,
    showChartFive: false,
    showChartSix: false,
    arrayRealizados: [],
    arrayNaoFaturados: [],
    arrayLatLng: [],
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    zoom: 8.5,
    center: [-5.877358, -35.632548], //inseri essas coordenadas manualmente inspecionando no google maps
    bounds: null,
    geoJson: null,
    showMap: false,
    arrayQuantidade:[],
    keyMunicipiosDatacom: null,
    arrayNormalizado: [],
    arrayNomeMunicipios: [],
    dataInicialMap: '',
    dataFinalMap: '',
    menuDataInicial: false,
    menuDataFinal: false,
    arrayHeatmap: [],
    colorScale: ["FFEDA0","FED976", "FEB24C", "FD8D3C", "FC4E2A", "E31A1C", "BD0026", "800026"],
    value: {
      key: "quantidade_empresas",
      metric: "empresas"
    },
    extraValues: [{
      key: "quantidade_atendimentos",
      metric: "atendimentos"
    }],
    mapOptions: {
      attributionControl: false
    },
    quantidadeSemanas: null,
    unidades:[],
    unidadesZeroTwo:[],
    IdUnidades:[],
    countUnidades: 0,
    registros2: 0,
    countMes:1,
  }),
  watch: {
    contractsSummaryDayInterval() {
      this.getContractsSummary();
    },
    programaExame(val) {
      val === 1
        ? this.getAtendimentosProgramas(val)
        : this.getAtendimentosExames(val)
    }
  },
  methods: {
    refreshStart(val) {
      this.dateStart = val,
      this.getQuantidadesDatacom() 
      this.getCharts()
    },
    refreshFinish(val) {
      this.dateFinish = val,
      this.getQuantidadesDatacom() 
      this.getCharts()
    },
    getDifference(){
      var d1 = new Date(moment().format('YYYY-MM-DD'));
      var d2 = new Date('2020-09-16');
      // eslint-disable-next-line no-undef
      this.quantidadeSemanas = Math.round((d1-d2)/ 604800000);
    },
    zoomUpdated (zoom) {
      this.zoom = zoom;
    },
    centerUpdated (center) {
      this.center = center;
    },
    boundsUpdated (bounds) {
      this.bounds = bounds;
    },
    getQuantidadesDatacom(){
      this.axios('dashboard/graficos/empresas/municipios/mapa',{
        params:{
          IdUnidade: this.IdUnidade,
          DataInicialMap: this.dataInicialMap,
          DataFinalMap: this.dataFinalMap,
          DateStart: this.dateStart,
          DateFinish: this.dateFinish
        }
      }).then(res => {
        if(this.showMap === true) {
            this.keyMunicipiosDatacom = null
            this.arrayQuantidade = []
            this.arrayLatLng = []
            this.arrayNormalizado = []
        }
        for (var i = 0; i < res.data.length; i++) {
          this.arrayQuantidade.push(
              {
                IBGE: res.data[i].IBGE,
                Total_Empresas: res.data[i].Total_Empresas,
                Total_Atendimentos: res.data[i].Total_Atendimentos
              }
          )
        }
        this.getLatLng()
      })
    },
    verificaMunicipio(value){
      for (var j=0; j < this.arrayQuantidade.length; j++) {
        if (this.arrayQuantidade[j].IBGE == value) {
          this.verificarExistencia = true
          //Variável para armazenar a posição da cidade encontrada
          this.keyMunicipiosDatacom = j
        }
      }
    },
    getNomeMunicipiosIBGE(){
      this.axios('https://servicodados.ibge.gov.br/api/v1/localidades/estados/24/municipios').then(res =>{
        for(var i = 0; i < res.data.length; i++){
          this.arrayNomeMunicipios.push(
              {
                ID: res.data[i].id,
                Nome: res.data[i].nome
              }
          )
        }
      })
    },
    getLatLng(){
      this.axios.get('https://servicodados.ibge.gov.br/api/v2/malhas/24?resolucao=5&formato=application/json').then((res) => {
        for(var i = 0; i < res.data.objects.foo.geometries.length; i++){
          this.verificaMunicipio(res.data.objects.foo.geometries[i].properties.codarea);
          if(this.verificarExistencia===true){
            this.arrayLatLng.push({
              codarea: res.data.objects.foo.geometries[i].properties.codarea,
              nome: this.arrayNomeMunicipios[i].Nome,
              //Variável armazenada sendo usada pra acessar as quantidades da cidade da datacom
              quantidade_empresas: this.arrayQuantidade[this.keyMunicipiosDatacom].Total_Empresas,
              quantidade_atendimentos: this.arrayQuantidade[this.keyMunicipiosDatacom].Total_Atendimentos,
              centroide: res.data.objects.foo.geometries[i].properties.centroide.reverse()
            })
          }
          this.verificarExistencia = null
          this.keyMunicipiosDatacom = null
        }

        this.arrayNormalizado = this.arrayLatLng.map(item => {
          const container = {};
          container.codarea = item.codarea;
          container.centroide = item.centroide;
          container.nome = item.nome;
          container.quantidade_empresas = item.quantidade_empresas;
          if(item.quantidade_atendimentos==null){
            container.quantidade_atendimentos = 0;
            //valor vem null do banco
          }else{
            container.quantidade_atendimentos = item.quantidade_atendimentos;
          }
          return container;
        })
        if(this.geoJson!=null){
          this.showMap = true
        }
       })
    },
    getUnidades() {
      this.axios('unidades').then(res => {
        this.unidadesList = res.data
      })
    },

    getContractsSummary() {
      this.contractsSummaryChartLoading = true,

      this.axios.get('dashboard/graficos/contratos/resumo', {
        params: {
          dayInterval: this.contractsSummaryDayInterval
        }
      })
        .then(res => {
          const resKeys = ['qtdNovoMes', 'qtdAgendado', 'qtdAtendimentoIniciado', 'qtdFaturado'];

          this.contractsSummaryOptions.xaxis.categories = [];
          this.contractsSummarySeries.forEach(series => series.data = []);
          
          res.data.forEach(item => {
            this.contractsSummaryOptions.xaxis.categories.push(item.Unidade)

            resKeys.forEach((key, i) => {
              this.contractsSummarySeries[i].data.push(item[key]);
            })
          });
        })
        .finally(() => {
          this.contractsSummaryChartLoading = false;
        });
    },

    getAtendimentosProgramas(flagPrograma) {
      this.axios.get('dashboard/graficos/servicos/atendimentos', {
        params:{
          IdUnidade: this.IdUnidade,
          DateStart: this.dateStart,
          DateFinish: this.dateFinish,
          flagProgramas: flagPrograma
        }
      }).then(res => {
        this.chartOptionsProgramasExames = {
          ...this.chartOptionsProgramasExames, ...{
            xaxis: {
              categories: []
            }
          }
        }
        this.seriesProgramasExames = [{...this.seriesProgramasExames[0], ...{
            name: '',
            data: []
          }
        }]

        if(res.data.length === 0){
          this.chartOptionsProgramasExames = {...this.chartOptionsProgramasExames, ...{
              noData:{
                text: 'Sem resultados para essa filtragem'
              }
            }}
        }

        res.data.filter(arr => {
          this.chartOptionsProgramasExames.xaxis.categories.push(arr.Procedimento)
          this.seriesProgramasExames[0].name = 'Quantidade de programas'
          this.seriesProgramasExames[0].data.push(arr.total)
        })
      })
    },

    getAtendimentosExames(flagPrograma) {
      this.axios.get('dashboard/graficos/servicos/atendimentos', {
        params:{
          IdUnidade: this.IdUnidade,
          DateStart: this.dateStart,
          DateFinish: this.dateFinish,
          flagProgramas: flagPrograma
        }
      }).then(res => {
        this.chartOptionsProgramasExames =
        {
          ...this.chartOptionsProgramasExames, 
          ...{
            xaxis: {
              categories: []
            }
          }
        }
        this.seriesProgramasExames = [
          {
            ...this.seriesProgramasExames[0],
            ...{
              name: '',
              data: []
            }
          }
        ]

        if(res.data.length === 0){
          this.chartOptionsProgramasExames = 
          {
            ...this.chartOptionsProgramasExames, 
            ...{
              noData: {
                text: 'Sem resultados para essa filtragem'
              }
            }
          }
        }

        res.data.filter(arr => {
          this.chartOptionsProgramasExames.xaxis.categories.push(arr.Procedimento)
          this.seriesProgramasExames[0].name = 'Quantidade de exames'
          this.seriesProgramasExames[0].data.push(arr.total)
        })
      })
    },

    getCharts(){
      this.axios.get('dashboard/graficos/indicadores/agendamentos', {
        params:{
          IdUnidade: this.IdUnidade,
          DateStart: this.dateStart,
          DateFinish: this.dateFinish
        }
      }).then(res =>{
        if(this.showChartFour === true){
          this.agendamentosTotal = 0
          this.agendamentosAgendados = 0
          this.agendamentosHoje = 0
          this.agendamentosConcluidos = 0
        }
        this.agendamentosTotal = res.data.Total;
        this.agendamentosAgendados = res.data.Agendados;
        this.agendamentosHoje = res.data.Hoje;
        this.agendamentosConcluidos = res.data.Concluidos;
      })

      this.axios.get('faturamentos/getFaturamentoTotal', {
        params:{
          IdUnidade: this.IdUnidade,
          DateStart: this.dateStart,
          DateFinish: this.dateFinish
        }
      }).then(res => {
        if(this.showChartZero === true) {
          for(var j = 0; j < this.unidades.length; j++){
              this.seriesZero = [{...this.seriesZero[j], ...{
                  name: '',
                  data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                }
              }]
          }
          this.unidades = [];
        }
        if(res.data.length === 0){
          this.chartOptionsZero = {...this.chartOptionsZero, ...{
              noData:{
                text: 'Sem resultados para essa filtragem'
              }
            }}
        }
        let count = 0;
        //percorrer todos os valores vindo da query
        for(var registros2 = 0; registros2<res.data.length; registros2++){
          //IdUnidade temporaria
          this.unidadeTemporaria = res.data[registros2].IdUnidade;
          //Saber se já existe o valor da IdUnidade no array unidades, caso não cria-lo, caso sim, atribuir valor no
          //no local do mês
          let index = this.unidades.findIndex(val => val == this.unidadeTemporaria);
          if(index < 0){
            this.unidades.push(res.data[registros2].IdUnidade);
            this.seriesZero[count] = {
                name: res.data[registros2].Unidade,
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }
            this.seriesZero[count].data.splice((res.data[registros2].mes - 1), 1, res.data[registros2].TotalFaturado);
            count++;
          }else{
            var indexSeries = this.unidades.indexOf(res.data[registros2].IdUnidade)
            this.seriesZero[indexSeries].data.splice((res.data[registros2].mes - 1), 1, res.data[registros2].TotalFaturado);
          }
        }
      })
      this.axios.get('faturamentos/getFaturamentoMesTotal', {
        params:{
          IdUnidade: this.IdUnidade,
          DateStart: this.dateStart,
          DateFinish: this.dateFinish
        }
      }).then(res => {
        if(this.showChartZeroTwo === true) {
          this.seriesZeroTwo = [{...this.seriesZeroTwo[0], ...{
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }
          },{...this.seriesZeroTwo[1], ...{
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }
          }]
        }
        if(res.data.length === 0){
          this.chartOptionsZeroTwo = {...this.chartOptionsZeroTwo, ...{
              noData:{
                text: 'Não há dados nesse gráfico para essa filtragem'
              }
            }}
        }
        for (var i = 0; i < res.data.length; i++) {
          this.seriesZeroTwo[0].data.splice((res.data[i].mes - 1), 1, res.data[i].ValorPago);
          this.seriesZeroTwo[1].data.splice((res.data[i].mes - 1), 1, res.data[i].ValorDevido);
        }
      })

      this.axios.get('dashboard/graficos/empresas/atendimentos',{
        params:{
          IdUnidade: this.IdUnidade,
          DateStart: this.dateStart,
          DateFinish: this.dateFinish
        }
      }).then(res => {
        if(this.showChartTwo === true){
          this.totalAtendimentosEmpresa = 0
          this.totalEmpresasAtendidas = null
          this.chartOptionsTwo = {...this.chartOptionsTwo, ...{
              seriesTwo: [],
              labels: [],
              subtitle: {
                text: ''
              }
            }}
        }
        if(res.data.length == 0){
          this.chartOptionsTwo = {...this.chartOptionsTwo, ...{
              noData:{
                text: 'Não há dados nesse gráfico para essa filtragem'
              }
            }}
        }else if(res.data.length <= 5){
          for(var i = 0; i < res.data.length; i++) {
            this.chartOptionsTwo.seriesTwo.push(parseInt(res.data[i].total))
            this.chartOptionsTwo.labels.push(res.data[i].RazaoSocial)
          }
        }else{
          for(i = 0; i < 5; i++) {
            this.chartOptionsTwo.seriesTwo.push(parseInt(res.data[i].total))
            this.chartOptionsTwo.labels.push(res.data[i].RazaoSocial)
          }
        }
        for(i = 0; i < res.data.length; i++) {
          this.totalAtendimentosEmpresa = (parseInt(res.data[i].total)) + this.totalAtendimentosEmpresa
        }
        this.totalEmpresasAtendidas = res.data.length
        this.chartOptionsTwo.subtitle.text = this.totalAtendimentosEmpresa + ' atendimentos realizados em ' + this.totalEmpresasAtendidas + ' empresas'
      })

      this.axios.get('dashboard/graficos/municipios/atendimentos',{
        params:{
          IdUnidade: this.IdUnidade,
          DateStart: this.dateStart,
          DateFinish: this.dateFinish
        }
      }).then(res => {
        if(this.showChartThree === true){
          this.totalMunicipiosAtendidos = 0
          this.chartOptionsThree = {...this.chartOptionsThree, ...{
              labels: []
            }}
          this.seriesThree = []
        }
        if(res.data.length === 0){
          this.chartOptionsThree = {...this.chartOptionsThree, ...{
              noData:{
                text: 'Sem resultados para essa filtragem'
              }
            }}
        }else if(res.data.length <= 5){
          for(var i = 0; i < res.data.length; i++) {
            this.chartOptionsThree.labels.push(res.data[i].Cidade)
            this.seriesThree.push(res.data[i].total)
          }
        }else{
          for(i = 0; i < 5; i++) {
            this.chartOptionsThree.labels.push(res.data[i].Cidade)
            this.seriesThree.push(res.data[i].total)
          }
        }
        this.totalMunicipiosAtendidos = res.data.length
      })

      /*
      this.axios.get('dashboard/graficos/faturamento',{
        params:{
          IdUnidade: this.IdUnidade,
          DateStart: this.dateStart,
          DateFinish: this.dateFinish
        }
      }).then(res => {
        if(this.showChartFour === true){
          this.arrayRealizados = []
          this.arrayNaoFaturados = []
        }
        for(var i = 0; i < res.data.length; i++) {
          this.arrayRealizados.push(res.data[i].Realizados)
          this.arrayNaoFaturados.push(res.data[i].Não_Faturados)
        }
      })
      
      this.axios.get('dashboard/graficos/faturamento/agendamentos',{
        params:{
          IdUnidade: this.IdUnidade,
          DateStart: this.dateStart,
          DateFinish: this.dateFinish
        }
      }).then(res => {
        if(this.showChartFour === true) {
          this.chartOptionsFour = {...this.chartOptionsFour, ...{
              xaxis: {
                categories: []
              }
            }
          }
          this.seriesFour = [{...this.seriesFour[0], ...{
              data: []
            }
          },{...this.seriesFour[1], ...{
              data: []
            }
          },{...this.seriesFour[2], ...{
              data: []
            }
          }]
        }
        if(res.data.length === 0){
          this.chartOptionsFour = {...this.chartOptionsFour, ...{
              noData:{
                text: 'Não há dados nesse gráfico para essa filtragem'
              }
            }}
        }
        for(var i = 0; i < res.data.length; i++) {
          var mesFormatado = moment(res.data[i].Periodo, 'YYYY/MM').format('MMMM [de] YYYY');
          this.chartOptionsFour.xaxis.categories.push(mesFormatado)
          this.seriesFour[0].data.push(res.data[i].Agendados)
          this.seriesFour[1].data.push(this.arrayRealizados[i])
          this.seriesFour[2].data.push(this.arrayNaoFaturados[i])
        }
      })*/

      this.axios.get('dashboard/graficos/empresas/municipios', {
        params:{
          IdUnidade: this.IdUnidade,
          DateStart: this.dateStart,
          DateFinish: this.dateFinish
        }
      }).then(res => {
        if(this.showChartFive === true) {
          this.chartOptionsFive = {
            ...this.chartOptionsFive, ...{
              xaxis: {
                categories: []
              }
            }
          }
          this.seriesFive = [{...this.seriesFive[0], ...{
              data: []
            }
          }]
        }
        if(res.data.length === 0){
          this.chartOptionsFive = {...this.chartOptionsFive, ...{
              noData:{
                text: 'Sem resultados para essa filtragem'
              }
            }}
        }
        for (var i = 0; i < res.data.length; i++) {
          this.chartOptionsFive.xaxis.categories.push(res.data[i].Cidade)
          this.seriesFive[0].data.push(res.data[i].Total_Empresas)
        }
      })
      this.axios.get('dashboard/graficos/agendamentos/dia', {
        params:{
          IdUnidade: this.IdUnidade,
          DateStart: this.dateStart,
          DateFinish: this.dateFinish
        }
      }).then(res => {
        if(this.showChartSix === true) {
          this.seriesSix = [{...this.seriesSix[0], ...{
              data: []
            }
          },{...this.seriesSix[1], ...{
              data: []
            }
          },{...this.seriesSix[2], ...{
              data: []
            }
          }]
        }
        if(res.data.length === 0){
          this.chartOptionsSix = {...this.chartOptionsSix, ...{
              noData:{
                text: 'Não há dados nesse gráfico para essa filtragem'
              }
            }}
        }
        for (var i = 0; i < res.data.length; i++) {
          this.seriesSix[0].data.push(res.data[i].Atendimentos)
          this.seriesSix[1].data.push(res.data[i].Agendados)
          this.seriesSix[2].data.push((res.data[i].Agendados)/this.quantidadeSemanas)
        }
      }).catch( () => {})
          .finally( () => {
            this.showChartZero = true
            this.showChartZeroTwo = true
            this.showChartOne = true
            this.showChartTwo = true
            this.showChartThree = true
            this.showChartFour = true
            this.showChartFive = true
            this.showChartSix = true
          })
    },

    limparFiltros(){
      this.IdUnidade = null
      this.dataFinalMap = ''
      this.dataInicialMap = ''
      this.getQuantidadesDatacom()
      this.getCharts()
    }
  },

  mounted() {
    this.programaExame = 1
    this.getDifference()
    this.getCharts()
    this.getUnidades()
    this.getQuantidadesDatacom()
    this.getNomeMunicipiosIBGE()
    this.getContractsSummary()
  },
  created () {
    //MALHA DO IBGE
    this.axios.get('https://servicodados.ibge.gov.br/api/v2/malhas/24?resolucao=5&formato=application/vnd.geo+json')
    .then(res => {
      this.geoJson = res.data;
    })
  }
};
</script>
